/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Button, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: { overflow: 'visible' },
  alert: {
    marginBottom: theme.spacing(3),
  },
  formGroup: {
    marginBottom: theme.spacing(3),
    width: '100%',
    flexGrow: 1,
  },
  formGroupGrid: {
    marginBottom: theme.spacing(3),
    flexGrow: 1,
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  addButton: {
    marginLeft: theme.spacing(1),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    bgcolor: 'background.white',
    boxShadow: 24,
  },
  modalActionCancel: {
    marginLeft: '2%',
  },
  modalActionPrimary: {
    marginLeft: '5%',
  },
}));

const DeleteConfirmPrompt = ({ data, deleteConfirm, hide }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSubmit = () => {
    deleteConfirm();
    hide();
  };

  return (
    <Card className={classes.modal}>
      <CardContent>
        <form
          onSubmit={() => {
            handleSubmit();
          }}
        >
          <Grid container spacing={3} alignItems="stretch">
            <Grid item xs={12} sm={12}>
              <Typography variant="h3">{t('data_delete_confirm')}</Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.formGroupGrid}>
                <Typography variant="h4">
                  {t('name')} : {data?.name ? data.name : data?.hw_address?.slice(data?.hw_address.length - 5)}
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Button onClick={hide} color="primary" className={classes.modalActionCancel}>
            {t('cancel')}
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained" className={classes.modalActionPrimary}>
            {t('delete')}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

DeleteConfirmPrompt.propTypes = {
  data: PropTypes.object,
  deleteConfirm: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

DeleteConfirmPrompt.defaultProps = {
  data: {},
};

export default DeleteConfirmPrompt;
